import { Chart } from 'chart.js';
const defaultOptions = {
    fillColor: '#cee6f3',
    strokeColor: '#d3e4ee',
    axis: 'x',
    base: 4,
    target: 6
};
function getLineValue(scale, index, offsetGridLines) {
    let lineValue = scale.getPixelForTick(index);
    if (offsetGridLines) {
        if (index === 0) {
            lineValue -= (scale.getPixelForTick(1) - lineValue) / 2;
        }
        else {
            lineValue -= (lineValue - scale.getPixelForTick(index - 1)) / 2;
        }
    }
    return lineValue;
}
function hasData(data) {
    return data && data.datasets && data.datasets.length > 0;
}
function findScale(chart, options) {
    const c = chart;
    const scales = Object.keys(c.scales).map((d) => c.scales[d]);
    return scales.find((d) => d.id.startsWith(options.axis));
}
export const strengthPlugin = {
    id: 'strengtharea',
    beforeDraw(chart, easing, options) {
        options = Object.assign({}, defaultOptions, options);
        const scale = findScale(chart, options);
        if (!hasData(chart.config.data) || !scale) {
            return;
        }
        const ticks = scale.getTicks();
        if (!ticks || ticks.length === 0) {
            return;
        }
        const { target, base } = options;
        const targetTick = ticks.findIndex((v) => v.value === base);
        const isHorizontal = scale.isHorizontal();
        const { chartArea } = chart;
        const { top, right, bottom } = chartArea;
        const soptions = scale.options;
        const gridLines = soptions.gridLines;
        const ctx = chart.ctx;
        ctx.save();
        ctx.fillStyle = options.fillColor;
        ctx.strokeStyle = options.strokeColor;
        ctx.setLineDash([3, 3]);
        const tickPositions = ticks.map((_, index) => getLineValue(scale, index, gridLines.offsetGridLines && ticks.length > 1));
        tickPositions.push(isHorizontal ? right : bottom);
        const [leftPos, rightPos] = targetTick > -1 ? [tickPositions[targetTick], tickPositions[target]] : [0, 0];
        const left = leftPos;
        const width = rightPos - leftPos;
        const height = bottom - top;
        ctx.fillRect(left, top, width, height);
        ctx.strokeRect(left, top, width, height);
        if (options.label.enabled) {
            const { text, strokeColor, fontSize = 8, fontStyle = 'normal', fontFamily = '"Helvetica Neue", Helvetica, Arial, sans-serif' } = options.label;
            const chartHelpers = Chart.helpers;
            ctx.font = chartHelpers.fontString(fontSize, fontStyle, fontFamily);
            const labelX = left + width / 2;
            const labelY = 0;
            ctx.fillStyle = strokeColor;
            ctx.strokeStyle = strokeColor;
            ctx.textBaseline = 'top';
            ctx.textAlign = 'center';
            ctx.fillText(text, labelX, labelY);
        }
        ctx.restore();
    }
};
